"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-7',
    connection_id: 'connection-12'
  },
  chain_2: {
    chain_name: 'kava',
    client_id: '07-tendermint-154',
    connection_id: 'connection-195'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-7',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-137',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-5',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'kujira',
    client_id: '07-tendermint-158',
    connection_id: 'connection-122'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-118',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-11',
    connection_id: 'connection-17'
  },
  chain_2: {
    chain_name: 'neutron',
    client_id: '07-tendermint-72',
    connection_id: 'connection-51'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-11',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-48',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'noble',
    client_id: '07-tendermint-59',
    connection_id: 'connection-57'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-33',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-3',
    connection_id: 'connection-7'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3009',
    connection_id: 'connection-2500'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-6787',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-4',
    connection_id: 'connection-8'
  },
  chain_2: {
    chain_name: 'persistence',
    client_id: '07-tendermint-159',
    connection_id: 'connection-197'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-131',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'stride',
    client_id: '07-tendermint-133',
    connection_id: 'connection-123'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-160',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-9',
    connection_id: 'connection-14'
  },
  chain_2: {
    chain_name: 'terra2',
    client_id: '07-tendermint-390',
    connection_id: 'connection-380'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-9',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-299',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;